import api from "../../../../../../api";
import React, { useEffect } from "react";
import utils from "../../../../../../utils";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { useQuery } from "react-query";
import { useFormik } from "formik";
import { ICreateAndUpdateDriver } from "../../../../../../types/driver.interface";
import { ICreateAndUpdateCompany } from "../../../../../../types/company.interface";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomInput, CustomTimePiker,
  CustomView, LocationDropdowns,
} from "../../../../../../components";

import * as Yup from "yup";
import TitleLine from "../../../../../../components/TitleLine";
import validations from "../../../../../../validations";
import { useTranslation } from "react-i18next";
import { gender, marital } from "../../../../../../values/dropdownItems";
import {locationNamespace} from "../../../../../../types/location.namespace";
import errorHandler from "../../../../../../utils/errorHandler";

type Props = {
  defaultValues: any;
  onSubmit: (event: ICreateAndUpdateDriver) => void;
};

const AdministratorDriverInformation = (props: Props) => {
  const { isLoading, setShowModal, selectedDriver } = React.useContext(Context.DriverScreen);
  const [selectedGender       , setSelectedGender ] = React.useState<IItem | undefined>(gender.filter((item) => {return item.value === props?.defaultValues?.gender})[0]);
  const [selectedMarital      , setSelectedMarital] = React.useState<IItem | undefined>(props?.defaultValues?.marital);
  const [selectedCompany      , setSelectedCompany] = React.useState<ICreateAndUpdateCompany>();
  const [selectedFinancialGroup, setFinancialGroup] = React.useState<string>();
  const [birthday, setBirthday] = React.useState<string>(props?.defaultValues?.birthday);

  const [selectedNeighborhood, setSelectedNeighborhood] = React.useState<locationNamespace.neighborhood.index | undefined>();
  const [selectedProvince    , setSelectedProvince    ] = React.useState<locationNamespace.province.index     | undefined>();
  const [selectedCity        , setSelectedCity        ] = React.useState<locationNamespace.city.index         | undefined>();
  const [selectedArea        , setSelectedArea        ] = React.useState<locationNamespace.area.index         | undefined>();

  const [searchedValue , setSearchedValue ] = React.useState<IOnSearchUser>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    gender: "",
    marital: "",
    company: "",
    city: "",
  });

  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValue],
    () =>
      api.post.administrator.getAllCompany({
        search: {
          base: searchedValue?.base.value,
          value: searchedValue?.searchedValue,
        },
      })
  );

  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  useEffect(() => {

    setSelectedCompany(
      companyInformationWithCompanyName?.find(
        (item: ICompanyItem) =>
          item?._id === props?.defaultValues?.schoolDriverInformation?.company
      )
    );
    setSelectedMarital(
      marital.find(
        (item: IItem) =>
          item?.value === props?.defaultValues?.schoolDriverInformation?.marital
      )
    );
    setFinancialGroup(
      props?.defaultValues?.companyInformation?.financialGroupSchool?._id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.defaultValues,
    getAllCompany?.data?.result,
  ]);


  const formik = useFormik<ICreateAndUpdateDriver>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: props?.defaultValues?.phoneNumber,
      firstName: props?.defaultValues?.firstName,
      lastName: props?.defaultValues?.lastName,
      fatherName: props?.defaultValues?.fatherName,
      nationalCode: props?.defaultValues?.driverInformation?.nationalCode,
      kartNumber: props?.defaultValues?.financial?.kartNumber,
      address: props?.defaultValues?.schoolDriverInformation?.address,
      shabaNumber: props?.defaultValues?.financial?.shabaNumber,
      fileNumber: props?.defaultValues?.schoolDriverInformation?.fileNumber,
      formNumber: props?.defaultValues?.schoolDriverInformation?.formNumber,
      tagNumber: props?.defaultValues?.schoolDriverInformation?.tagNumber,
    },
    validationSchema: Yup.object({
      address     : validations.yupValidations.address     ,
      lastName    : validations.yupValidations.lastName    ,
      firstName   : validations.yupValidations.firstName   ,
      kartNumber  : validations.yupValidations.kartNumber  ,
      phoneNumber : validations.yupValidations.phoneNumber ,
      shabaNumber : validations.yupValidations.shabaNumber ,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: ICreateAndUpdateDriver, { setSubmitting }) => {
      if (!selectedCompany && !selectedDriver?.schoolDriverInformation?.company) return utils.errorHandler(9013);
      const formValues: ICreateAndUpdateDriver = {
        ...values,
        gender: selectedGender,
        marital: selectedMarital,
        company: selectedCompany ? selectedCompany : selectedDriver?.schoolDriverInformation?.company?.companyInformation,
        birthday: birthday ? birthday : undefined,

        city        : selectedCity         ? selectedCity        ?._id : selectedDriver?.schoolDriverInformation?.city        ?._id,
        area        : selectedArea         ? selectedArea        ?._id : selectedDriver?.schoolDriverInformation?.area        ?._id,
        province    : selectedProvince     ? selectedProvince    ?._id : selectedDriver?.schoolDriverInformation?.province    ?._id,
        neighborhood: selectedNeighborhood ? selectedNeighborhood?._id : selectedDriver?.schoolDriverInformation?.neighborhood?._id,

        financialGroupSchool: selectedFinancialGroup,
      };
      Promise.resolve(props.onSubmit(formValues)).catch((e) =>
        setSubmitting(false)
      );
    },
  });

  const { t } = useTranslation();

  const submitHandler = () => {
    let dropDownErrorsList = {
      neighborhood: '',
      province: '',
      company: '',
      marital: '',
      gender: '',
      city: '',
      area: '',
    };
    if (!selectedGender) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        gender: t("gender_is_required"),
      };
    }
    if (!selectedMarital) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        marital: t("marital_is_required"),
      };
    }
    if (!selectedCompany && !selectedDriver?.schoolDriverInformation?.company) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        company: t("company_is_required"),
      };
    }

    if (!selectedProvince && !selectedDriver?.schoolDriverInformation?.province) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        province: t("province_is_required"),
        city: t("city_is_required"),
        area: 'انتخاب منطقه اجباری میباشد',
        neighborhood: 'انتخاب محله اجباری میباشد',
      };
    } else if (!selectedCity && !selectedDriver?.schoolDriverInformation?.city) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        city: t("city_is_required"),
        area: 'انتخاب منطقه اجباری میباشد',
        neighborhood: 'انتخاب محله اجباری میباشد',
      };
    } else if (!selectedArea && !selectedDriver?.schoolDriverInformation?.area) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        area: 'انتخاب منطقه اجباری میباشد',
        neighborhood: 'انتخاب محله اجباری میباشد',
      };
    } else if (!selectedNeighborhood && !selectedDriver?.schoolDriverInformation?.neighborhood) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        neighborhood: 'انتخاب محله اجباری میباشد',
      };
    }

    setDropDownErrors(dropDownErrorsList);

    formik.submitForm();
  };

  function onSelectProvince (event: locationNamespace.province.index | undefined): void {
    setSelectedProvince(event);
    setSelectedNeighborhood(undefined);
    setSelectedCity(undefined);
    setSelectedArea(undefined);
    setDropDownErrors({
      ...dropDownErrors,
      province: ''
    });
  }

  function onSelectCity (event: locationNamespace.city.index | undefined): void {
    setSelectedNeighborhood(undefined);
    setSelectedCity(event);
    setSelectedArea(undefined);
    setDropDownErrors({
      ...dropDownErrors,
      city: ''
    });
  }

  function onSelectArea (event: locationNamespace.area.index | undefined): void {
    setSelectedNeighborhood(undefined);
    setSelectedArea(event);
    setDropDownErrors({
      ...dropDownErrors,
      area: ''
    });
  }

  function onSelectNeighborhood (event: locationNamespace.neighborhood.index | undefined): void {
    setSelectedNeighborhood(event);
    setDropDownErrors({
      ...dropDownErrors,
      neighborhood: ''
    });
  }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="update-form-content">
        <TitleLine title={t("driverInfo")} />
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("company")}</label>

            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={companyInformationWithCompanyName}
              itemName="companyName"
              onSelectItem={(event: any) => {
                setSelectedCompany(event);
                setDropDownErrors({ ...dropDownErrors, company: "" });
                setFinancialGroup(
                  event?.companyInformation?.financialGroupSchool?._id
                );
              }}
              defaultItem={selectedCompany ? selectedCompany : selectedDriver?.schoolDriverInformation?.company?.companyInformation}
              searchedValue={searchedValue}
              setSearchedValue={setSearchedValue}
              placeHolder={t("selectCompany")}
              isLoading={getAllCompany.isLoading}
              selectedBaseSearch={
                searchedValue?.base?.value === "nationalCode"
                  ? "companyInformation.nationalCode"
                  : searchedValue?.base?.value
              }
            />
            <div className="error">
              {dropDownErrors.company !== "" && dropDownErrors.company}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <CustomInput
              id="phoneNumber"
              name="phoneNumber"
              label={t("phoneNumber")}
              value={formik.values.phoneNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              errorText={formik.errors.phoneNumber}
              maxLength={11}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="firstName"
              id="firstName"
              label={t("firstName")}
              value={formik.values.firstName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.firstName && formik.touched.firstName}
              errorText={formik.errors.firstName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="lastName"
              id="lastName"
              label={t("lastName")}
              value={formik.values.lastName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.lastName && formik.touched.lastName}
              errorText={formik.errors.lastName}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="fatherName"
              id="fatherName"
              label={t("fatherName")}
              value={formik.values.fatherName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={
                formik.errors.fatherName && formik.touched.fatherName
              }
              errorText={formik.errors.fatherName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <label className="form-label">{t("birthday")}</label>
            <CustomTimePiker
              defaultValue={birthday}
              onChange={(event: string) => {
                setBirthday(event);
              }}
            />
            <div className="error">
              {dropDownErrors.expireDate !== "" && dropDownErrors.expireDate}
            </div>
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <LocationDropdowns.Province
              defaultItem={selectedProvince ? selectedProvince : selectedDriver?.schoolDriverInformation?.province}
              onSelectItem={onSelectProvince}
              isError={dropDownErrors.province}
              errorText={dropDownErrors.province}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <LocationDropdowns.City
              defaultItem={selectedCity ? selectedCity : selectedDriver?.schoolDriverInformation?.city}
              onSelectItem={onSelectCity}
              selectedProvince={selectedProvince ? selectedProvince : selectedDriver?.schoolDriverInformation?.province}
              isError={dropDownErrors.city}
              errorText={dropDownErrors.city}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <LocationDropdowns.Area
              defaultItem={selectedArea ? selectedArea : selectedDriver?.schoolDriverInformation?.area}
              onSelectItem={onSelectArea}
              selectedCity={selectedCity ? selectedCity : selectedDriver?.schoolDriverInformation?.city}
              isError={dropDownErrors.area}
              errorText={dropDownErrors.area}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <LocationDropdowns.Neighborhood
              defaultItem={selectedNeighborhood ? selectedNeighborhood : selectedDriver?.schoolDriverInformation?.neighborhood}
              onSelectItem={onSelectNeighborhood}
              selectedArea={selectedArea ? selectedArea : selectedDriver?.schoolDriverInformation?.area}
              isError={dropDownErrors.neighborhood}
              errorText={dropDownErrors.neighborhood}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("gender")}</label>

            <CustomDropdownSearch
              items={gender.map((item) => {
                return { ...item, name: t(item.name as string) };
              })}
              itemName="name"
              placeHolder={t("selectGender")}
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setDropDownErrors({ ...dropDownErrors, gender: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.gender !== "" && dropDownErrors.gender}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("marital")}</label>

            <CustomDropdownSearch
              items={marital.map((item) => {
                return { ...item, name: t(item.name as string) };
              })}
              itemName="name"
              placeHolder={t("selectMarital")}
              defaultItem={selectedMarital}
              onSelectItem={(event: any) => {
                setSelectedMarital(event);
                setDropDownErrors({ ...dropDownErrors, marital: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.marital !== "" && dropDownErrors.marital}
            </div>
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum ">
            <CustomInput
              name="nationalCode"
              id="nationalCode"
              label={t("nationalCode")}
              value={formik.values.nationalCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.nationalCode && formik.touched.nationalCode}
              errorText={formik.errors.nationalCode}
              maxLength={10}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="kartNumber"
              id="kartNumber"
              label={t("cardNumber")}
              value={formik.values.kartNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.kartNumber && formik.touched.kartNumber}
              errorText={formik.errors.kartNumber}
              maxLength={16}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="address"
              id="address"
              label={t("address")}
              value={formik.values.address}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.address && formik.touched.address}
              errorText={formik.errors.address}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="shabaNumber"
              id="shabaNumber"
              label={t("shabaNumber")}
              value={formik.values.shabaNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.shabaNumber && formik.touched.shabaNumber}
              errorText={formik.errors.shabaNumber}
              maxLength={24}
              isShaba
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row" style={{ marginBottom: '40px' }}>
          <CustomView.Column medium={4} className="">
            <CustomInput
              name="fileNumber"
              id="fileNumber"
              label={t("fileNumber")}
              value={formik.values.fileNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.fileNumber && formik.touched.fileNumber}
              errorText={formik.errors.fileNumber}
            />
          </CustomView.Column>
          <CustomView.Column medium={4} className="">
            <CustomInput
              name="formNumber"
              id="formNumber"
              label={t("formNumber")}
              value={formik.values.formNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.formNumber && formik.touched.formNumber}
              errorText={formik.errors.formNumber}
            />
          </CustomView.Column>
          <CustomView.Column medium={4} className="">
            <CustomInput
              name="tagNumber"
              id="tagNumber"
              label={t("tagNumber")}
              value={formik.values.tagNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.tagNumber && formik.touched.tagNumber}
              errorText={formik.errors.tagNumber}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => setShowModal!("NONE")}
              title={t("cancel")}
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title={t("next")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default AdministratorDriverInformation;
